/* eslint-disable react/jsx-props-no-spreading */
import { useRouter } from 'next/router';
import ErrorPage from 'next/error';
import { format } from 'date-fns';

import { getRates } from '@utils/cred';

import { getPostBySlug, getAllPosts } from '@utils/readFiles';

import BuyPages from '../src/templates/BuyPages';
import PricePages from '../src/templates/PricePages';
import PricePagesUSD from '../src/templates/PricePages-USD';
import Articles from '../src/templates/Articles';

export default function Post({
	post,
}: {
	post: Record<string, number | string | boolean> & {
		title: string;
		description: string;
		path: string;
		noIndex?: string;
		heading: string;
		content: string;
	};
}) {
	const router = useRouter();

	if (!router.isFallback && !post?.path) {
		return <ErrorPage statusCode={404} />;
	}

	if (router.isFallback) {
		return 'Loading…';
	}

	if (post.template === 'buy') {
		return <BuyPages {...post} />;
	}

	if (post.template === 'priceInr') {
		return <PricePages {...post} />;
	}

	if (post.template === 'priceUsd') {
		return <PricePagesUSD {...post} />;
	}

	if (post.template === 'articles') {
		return <Articles {...post} />;
	}

	return <ErrorPage statusCode={404} />;
}

const tickerData: Record<
	string,
	{
		sellPrice: number;
		buyPrice: number;
		lastTradePrice: number;
		yes_price: number;
		inr_price?: number;
	}
>[] = [];

export async function getStaticProps({
	params,
}: {
	params: {
		slug: string[];
	};
}) {
	const post = getPostBySlug(params.slug.join('/'));

	const isUSD = post.template === 'priceUsd';

	if (post.template === 'priceInr' || post.template === 'priceUsd') {
		if (tickerData.length === 0) {
			const resp = (await getRates('full')) as Record<
				string,
				{
					sellPrice: number;
					buyPrice: number;
					lastTradePrice: number;
					yes_price: number;
				}
			>[];

			tickerData.push(...resp);
		}

		// post.tickerData = tickerData;
		const token = post.coin as string;
		let usdtRate = 0;
		tickerData.find(el => {
			if (isUSD) {
				if (`${token}USDT` === Object.keys(el)[0]) {
					post.coinPrice = el[`${token}USDT`].lastTradePrice;
					usdtRate = el[`${token}USDT`].inr_price / +post.coinPrice;
					return true;
				}
			} else if (token === Object.keys(el)[0]) {
				post.coinPrice = el[token].lastTradePrice;
				return true;
			}

			return false;
		});

		post.usdtRate = usdtRate;
	}

	post.graphPoints = [];
	// const coinId = getCoinProperty(post.coin, 'coinId') as number;

	switch (post.showPrice) {
		case 1: {
			try {
				const [{ status, data: bnsTickerData }] = (await fetch(
					`https://bitbns.com/graphData/?graphType=1&market=${
						isUSD ? 'USDT' : 'INR'
					}&coin=${(post.coin as string).toUpperCase()}`
				).then(res => res.json())) as [
					{
						status: 0 | 1;
						data: {
							time: string;
							close: number;
						}[];
					}
				];

				post.graphPoints =
					status === 1
						? bnsTickerData
								.filter((el, index) => index % 10 === 0)
								.map(el => ({
									time: format(
										new Date(+el.time * 1000),
										'yyyy-MM-dd hh:mm:ss.SSSS'
									),
									rate: el.close,
								}))
						: [];
			} catch (error) {
				console.log('[ERROR] bitbns', error, post.coin);
			}
			break;
		}
		case 2: {
			try {
				const binancePrices = (await fetch(
					'https://api.binance.com/api/v1/ticker/allPrices'
				).then(res => res.json())) as {
					symbol: string;
					price: number;
				}[];

				const actualCoin =
					post.coin === 'MIOTA' ? 'IOTA' : (post.coin as string);

				const newtickerData = binancePrices.filter(
					el => el.symbol === `${actualCoin}BTC`
				)[0];
				if (newtickerData !== undefined) {
					post.coinPrice =
						newtickerData.price * tickerData[0].BTC.lastTradePrice;
				}
			} catch (error) {
				console.log('[ERROR] binance', error, post.coin);
			}
			break;
		}
		case 3: {
			try {
				const customParam = `BTC-${post.coin as string}`;

				const { success, result } = (await fetch(
					`https://bittrex.com/api/v1.1/public/getticker?market=${customParam}`
				).then(res => res.json())) as {
					success: boolean;
					message: string;
					result: {
						Bid: number;
						Ask: number;
						Last: number;
					};
				};

				const newtickerData = success && result.Last;

				if (newtickerData !== undefined) {
					post.coinPrice =
						newtickerData * tickerData[0].BTC.lastTradePrice;
				}
			} catch (error) {
				console.log('[ERROR] bittrex', error, post.coin);
			}
			break;
		}
		default: {
			post.coinPrice = 0;
		}
	}
	// const content = await markdownToHtml((post.content as string) || '');

	return {
		props: {
			post,
		},
	};
}

export function getStaticPaths() {
	const posts = getAllPosts();

	return {
		paths: posts.map(post => {
			return {
				params: {
					slug: (post.slug as string).split('/'),
				},
			};
		}),
		fallback: false,
	};
}
